import React, { Component } from 'react'
import DarkThemeNav from '../common/dark-theme-nav';

class Breadcrumb extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor"id="breadcrumb"></a>
    <h2>Breadcrumb</h2>
    { this.props.staticVersion === false ? (
      <Included
      onClick={() => this.props.onIncludeClick()}
      included={this.props.included}/>
    ) : ( '' ) }
    <DarkThemeNav anchor="breadcrumbs" />
    <div className="soft">
    <ol className="breadcrumb">
    	<li ><a href="#">Top level</a></li>
    	<li data-breadcrumb="/"><a href="#">Level 1</a></li>
    	<li data-breadcrumb="/"><a href="#">Level 2</a></li>
    	<li data-breadcrumb="/" className="breadcrumb__current"><a href="#">Level 3</a></li>
</ol>
</div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<ol class="breadcrumb"><
      <li ><a href="#">Top level</a></li>
      <li data-breadcrumb="/"><a href="#">Level 1</a></li>
      <li data-breadcrumb="/"><a href="#">Level 2</a></li>
      <li data-breadcrumb="/" class="breadcrumb__current"><a href="#">Level 3</a></li>
    </ol>`}</code></pre>
    <br/>

    <div className="soft">
      <ol className="breadcrumb">
        <li><a href="#">Home</a></li>
        <li data-breadcrumb="|" className="breadcrumb__current"><a href="#">About</a></li>
        <li data-breadcrumb="|"><a href="#">The Board</a></li>
        <li data-breadcrumb="|"><a href="#">Directors</a></li>
      </ol>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<ol class="breadcrumb">
	<li><a href="#">Home</a></li>
	<li data-breadcrumb="|" class="breadcrumb__current"><a href="#">About</a></li>
	<li data-breadcrumb="|"><a href="#">The Board</a></li>
	<li data-breadcrumb="|"><a href="#">Directors</a></li>
</ol>`}</code></pre>
    <br/>
    <hr />
    </section>
  )
}
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./styleguide/components/sections/Breadcrumb.js